<tt-page *ngIf="page">
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="editUserGroupTable"></ng-container>
        </tt-card>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card ttHeading="h_usergroup_table_edit">
            <ng-container *ngTemplateOutlet="editUserGroupTable"></ng-container>
        </tt-card>
    </ng-container>
</tt-page>

<ng-template #editUserGroupTable>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="table_name" [ttModel]="page.table_name" ttReadonly></tt-input>
        <tt-input ttLabel="usergroup_name" [ttModel]="page.usergroup_name" ttReadonly></tt-input>
        <tt-select ttLabel="recordright" [(ttModel)]="page.recordright_no" [ttData]="recordRights" ttDataId="item_id" ttDataName="item_name" [ttShowClearButton]="page.recordright_no !== '10'" [ttClearValue]="'10'"></tt-select>
        <tt-button-save ttText="save" ttTextAlign="center" [ttLoading]="saving" (ttClick)="save()"></tt-button-save>
    </ng-container>
</ng-template>
